module.exports = __webpack_public_path__ + "img/petstairs23.095e8927.jpg";